import PropTypes from "prop-types";
import { useState } from "react";
import { InputNumber, Slider } from "antd";
import { DashboardOutlined } from "@ant-design/icons";
import CheckInImageUpload from "./CheckInImageUpload";

export const DEFAULT_FUEL_LEVEL = 25;
export const DEFAULT_MILEAGE = 0.0;
const DASHBOARD_IMAGE_NAME = "Dashboard";

const DashboardMileageSection = ({ onDataChange, t }) => {
    const [dashboardImage, setDashboardImage] = useState({
        id: 0,
        name: DASHBOARD_IMAGE_NAME,
        initialPlaceholder: "/logos/carDashboard.png",
        uploadedImageFile: "",
        create: false,
        key: "dashboard",
    });
    const [fuelLevel, setFuelLevel] = useState(DEFAULT_FUEL_LEVEL);
    const [mileage, setMileage] = useState(DEFAULT_MILEAGE);

    const emitChange = (file, nextFuel, nextMileage) => {
        onDataChange?.({ dashboardFile: file, fuelLevel: nextFuel, mileage: nextMileage });
    };

    const handleFileSelect = (newImageObj) => {
        if (newImageObj.name !== DASHBOARD_IMAGE_NAME && newImageObj.id !== 0) return;

        const file = newImageObj.uploadedImageFile || null;
        setDashboardImage((prev) => ({
            ...prev,
            uploadedImageFile: file,
            name: DASHBOARD_IMAGE_NAME,
            id: 0,
            create: false,
        }));
        emitChange(file, fuelLevel, mileage);
    };

    const handleFuelChange = (value) => {
        setFuelLevel(value);
        emitChange(dashboardImage.uploadedImageFile || null, value, mileage);
    };

    const handleMileageChange = (value) => {
        const mileageValue = Number(value) || 0;
        setMileage(mileageValue);
        emitChange(dashboardImage.uploadedImageFile || null, fuelLevel, mileageValue);
    };

    return (
        <div>
            <h2 className="fontSemi text-lg text-[#101828]">{t("dashboardSection")}</h2>
            <p className="fontRegular mb-4 mt-1 text-sm text-[#667085]">{t("dashboardInstructions")}</p>

            <CheckInImageUpload
                layout="wide"
                handleFileSelect={handleFileSelect}
                imageObj={dashboardImage}
                emptyIcon={<DashboardOutlined className="text-2xl text-[#101828]" />}
                t={t}
            />

            <div className="mt-6">
                <label className="fontRegular mb-3 block text-sm font-medium text-[#101828]">{t("fuelLevel")}</label>
                <Slider
                    min={0}
                    max={100}
                    step={25}
                    marks={{ 0: "0%", 25: "25%", 50: "50%", 75: "75%", 100: "100%" }}
                    value={fuelLevel}
                    onChange={handleFuelChange}
                    className="!mb-6 [&_.ant-slider-dot]:border-[#D0D5DD] [&_.ant-slider-dot]:bg-[#D0D5DD] [&_.ant-slider-handle]:border-[#5D5DF6] [&_.ant-slider-handle]:bg-white [&_.ant-slider-mark-text]:text-xs [&_.ant-slider-mark-text]:text-[#667085] [&_.ant-slider-rail]:bg-[#E4E7EC] [&_.ant-slider-track]:bg-[#5D5DF6]"
                />
            </div>

            <div className="mt-2 w-full">
                <label className="fontRegular mb-2 block text-sm font-medium text-[#101828]">{t("mileage")}</label>
                <InputNumber
                    type="number"
                    className="!w-full [&_input]:!w-full [&_input]:!text-[#101828]"
                    style={{ width: "100%" }}
                    size="large"
                    controls={false}
                    min={0}
                    step={0.2}
                    precision={2}
                    value={mileage}
                    onChange={handleMileageChange}
                />
            </div>
        </div>
    );
};

DashboardMileageSection.propTypes = {
    onDataChange: PropTypes.func,
    t: PropTypes.func.isRequired,
};

export default DashboardMileageSection;
